module.exports = __webpack_public_path__ + "img/circle-arrow.66172c23.svg";